import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = localStorage.getItem('access_token');
    if (request.url.match(/token/gi)) {
      const refreshTokenRequest = request.clone({
        setHeaders: {
          Authorization: "Basic " + btoa("android-client:android-secret"),
          "Content-Type": "application/x-www-form-urlencoded",
        }
      });
      return next.handle(refreshTokenRequest);
    }
    // The CRM createCase endpoint authenticates with our Bearer access token,
    // so let it flow through the interceptor. Other CRM calls (e.g.
    // getAppointmentDetails) authenticate via their own X-API-KEY and set that
    // header themselves, so we must not attach the Bearer token to those.
    const isCrmRequest = request.url.includes('/crmservice/');
    const isCrmCreateCase = request.url.includes('/crmservice/createCase');
    const skipBearer = isCrmRequest && !isCrmCreateCase;
    if (accessToken && !skipBearer) {
      const updateRequest = request.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + accessToken
        }
      });
      return next.handle(updateRequest);
    }
    return next.handle(request);
  }
}
